import { createContext } from "react";
import { FinancialDocumentView } from "@common/types/views/financialDocumentViews";

export const FinancialDocumentsBulkTaskViewContext =
    createContext<FinancialDocumentView | null>(null);
